export default [
    {
        path: '/biblioteca',
        name: 'admin.docs',
        meta: { nombre: 'Biblioteca' },
        component: () => import('../../pages/biblioteca/carpetas.vue').then(m => m.default || m)
    },
    {
        path: '/biblioteca/:id_carpeta',
        name: 'admin.docs.ver',
        meta: { nombre: 'Biblioteca' },
        component: () => import('../../pages/biblioteca/documentos.vue').then(m => m.default || m)
    },
]